// Frontend mirror of the token catalog implemented in
// backend/Proact.Shared/Services/Badges/Domain/BadgeTemplateTokenCatalog.cs.
// Keep in sync if the backend catalog changes — there is no shared source
// between the two stacks for this reference data.
export interface BadgeTemplateTokenDefinition {
  token: string;
  aliases?: string[];
  description: string;
}

export const BADGE_TEMPLATE_TOKENS: BadgeTemplateTokenDefinition[] = [
  {
    token: 'PersonnelName',
    aliases: ['EmployeeName'],
    description: "The person's full name.",
  },
  {
    token: 'FirstName',
    description: "The person's first name.",
  },
  {
    token: 'LastName',
    description: "The person's last name.",
  },
  {
    token: 'EmployeeId',
    aliases: ['ZNumber'],
    description: "The person's employee ID.",
  },
  {
    token: 'CompanyName',
    aliases: ['VendorName'],
    description:
      "The contractor's vendor/company name. Empty (with a warning) for contractors without a vendor and for employees.",
  },
  {
    token: 'PersonnelPhotoDataUri',
    aliases: ['EmployeePhotoDataUri'],
    description:
      "The person's photo, inlined as a data URI. Falls back to a placeholder silhouette if no photo is on file.",
  },
  {
    token: 'TrainingQRCodeDataUri',
    description:
      "QR code (data URI) linking to the personnel record's Training tab.",
  },
  {
    token: 'PersonnelQRCodeDataUri',
    description: 'QR code (data URI) linking to the personnel record.',
  },
  {
    token: 'BadgeExpirationDate',
    description:
      'Badge expiration date for contractors. Empty for employees.',
  },
  {
    token: 'InstanceName',
    description: 'The name of the instance (organization).',
  },
  {
    token: 'InstanceLogoDataUri',
    description: 'The instance logo, inlined as a data URI.',
  },
  {
    token: 'GeneratedDate',
    description: 'The date the badge was generated, set by the server.',
  },
];
